export class XMediaStreamPlayer extends HTMLElement {
	private _url: string;
	private _thumbnail: string;
	private container: HTMLDivElement;

	constructor() {
		super();
		this.attachShadow({ mode: 'open' });

		// Create a container that will hold either the thumbnail or the iframe
		this.container = document.createElement('div');
		this.container.classList.add('media-container');
		this.shadowRoot.appendChild(this.container);
	}

	// Use connectedCallback to set up the initial state
	connectedCallback(): void {
		this._url = this.getAttribute('data-url');
		this._thumbnail = this.getAttribute('data-thumbnail');
		this.updateContent();
	}

	// Function to update the content
	private updateContent(): void {
		const elementStyle = `
      <style>
        .media-container {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        .thumbnail, iframe {
          width: 100%;
          height: 100%;
          background: url('${this._thumbnail}') center center / cover no-repeat;
        }
        .play-button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          cursor: pointer;
          font-size: 60px;
        }
        .icon-play-button {
          width: 60px;
          height: 60px;
          fill: #fff;
        }
      </style>
    `;

		if (this._thumbnail) {
			this.container.innerHTML = `
        ${elementStyle}
        <div class="thumbnail">
          <div class="play-button">
            <svg
              class="icon-play-button"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              class="icon-play-button"
              fill="none"
              viewBox="0 0 10 14"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/>
            </svg>
          </div>
        </div>
      `;
			this.container.querySelector('.thumbnail').addEventListener('click', () => this.loadIframe());
		}
	}

	// Function to replace the image with the iframe
	private loadIframe(): void {
    const elementStyle = `
      <style>
        .media-container {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        iframe {
          width: 100%;
          height: 100%;       
        }
      </style>
    `;
		if (this._url) {
      const autoplayUrl = `${this._url}&autoplay=1&mute=1&cc_load_policy=1`;

			this.container.innerHTML = `
        ${elementStyle}
        <iframe src="${autoplayUrl}" frameborder="0" allowfullscreen allow="autoplay"></iframe>
      `;
		}
	}

	// Getters and setters for attributes
	get url(): string {
		return this._url;
	}

	set url(value: string) {
		this._url = value;
		this.updateContent();
	}

	get thumbnail(): string {
		return this._thumbnail;
	}

	set thumbnail(value: string) {
		this._thumbnail = value;
		this.updateContent();
	}
}

// Define the custom element
if (!customElements.get('x-media-stream-player')) {
	customElements.define('x-media-stream-player', XMediaStreamPlayer);
}
